<template>
  <el-menu
    :default-active="defaultActive"
    unique-opened
    router
  >
    <menu-tree-item
      v-for="item in treeData"
      :data="item"
      :key="`${item.type || 'leaf'}-${item.id}`"
    />
  </el-menu>
</template>

<script>
import MenuTreeItem from './MenuTreeItem';

export default {
  name: 'MenuTree',
  components: { MenuTreeItem },
  props: {
    defaultActive: {
      default() {
        return '';
      },
      type: String,
    },
    treeData: {
      default() {
        return [];
      },
      type: Array,
    },
  },
};
</script>

<style scoped>

</style>
